module.exports = __webpack_public_path__ + "img/AUTO_MEDICAMENT_ACTIVE.30cf4bfa.svg";